
export const COOKIES_BANNER_STATE_TAG = "banner_accepted";

export class CookiesHelper {
  constructor() {

  }

  static writeBannerAccepted(stateBool) {
    let year = 60 * 60 * 24 * 365; // 1an
    window.$cookies.set(COOKIES_BANNER_STATE_TAG, stateBool.toString(), year);
  }

  static readBannerState() {
    let has_cookies = window.$cookies.isKey(COOKIES_BANNER_STATE_TAG) ? true : false;

    if(has_cookies) {
      return window.$cookies.get(COOKIES_BANNER_STATE_TAG) == "true" ? true : false;
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/helpers/cookies-helper.js